module.exports = __webpack_public_path__ + "img/2Ne-jT4Hrq0YHpqbbczTWW.ba7e8fcc.png";